// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"english-rectangle"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M22 4V20H2L2 4L22 4Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M22 4V20L2 20L2 4L22 4Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M10 9H6.5C6.22386 9 6 9.19188 6 9.42857V12M6 12H10M6 12V14.5714C6 14.8081 6.22386 15 6.5 15H10M14 15V9H17.5556C17.801 9 18 9.19188 18 9.42857V15","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-english-rectangle')
export default class EnglishRectangleIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'english-rectangle',
    }
  }
}
